module.exports = {
  insuranceNewCar: { human: 'Neuzulassung', api: 'insuranceNewCar' },
  insuranceExistingCar: { human: 'Versichererwechsel', api: 'insuranceExistingCar' }
}
